// MODULES
import React from "react";
import Modal from "@components/Modal/Modal";
import i18n from "@helpers/i18n";

export default class SendToAdvisorModal extends React.PureComponent {

	render()
	{
		const {visible, title, onCloseModal, onSend, isSigning} = this.props;

		// const advisorName = `${advisor.first_name || advisor.firstName} ${advisor.last_name || advisor.lastName}`;

		return (
			<Modal
				className="Cob-SignAgreement-SendToAdvisorModal"
				visible={visible}
				title={title}>

				<p>Meddela rådgivare att ett utkast har skapats för den här kunden?</p>

				<Modal.ButtonsContainer>
					<Modal.Button
						label={i18n("general", "cancel")}
						onClick={onCloseModal}
						disabled={isSigning} />

					<Modal.Button
						key="go-sign-page"
						// label={i18n("general", "notify_advisor")}
						label={title}
						appearance="primary"
						onClick={onSend}
						disabled={isSigning}
						filled/>
				</Modal.ButtonsContainer>
			</Modal>
		);
	}
}


// WEBPACK FOOTER //
// ./src/routes/Cob/views/SendToAdvisorModal/SendToAdvisorModal.js